var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedRegularIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 391.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#a51e28;}.cls-3{fill:#ee2c51;}.cls-4{fill:#371415;}.cls-5{fill:#2c1112;}.cls-6{fill:#8b191e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,231.18C517.13,228.83,318.89,22.73,311,14.4c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.08-14.29-.8-14.29-.8s-4-5.24-17.63-1.28C233.58,14.78,7.86,72.14,7.86,72.14S.77,74,.69,81.23,0,126,0,126,195.25,377.36,202.91,387.32c6.27,8.2,22,2.49,22,2.49S509,286.84,515.64,284.4c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,233.29,519.39,231.18Zm-97.22-58.92-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L424,165C426.66,167.78,425.83,171.06,422.17,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483.51,185.58c-1.89-2-167.08-173.72-173.7-180.65-7.12-7.46-16.57-4-16.74-4,.08,0,.55-.23-7.94,2.2-9,2.58-11.92-.66-11.92-.66s-3.28-4.36-14.69-1.07C245.33,5.24,57.23,53,57.23,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3,162.71,209.48,169.1,217.78c5.22,6.83,18.36,2.08,18.36,2.08S474.87,232,480.38,229.92c4.84-2.07,4.5-6.38,4.5-6.38L485,192S485.15,187.34,483.51,185.58Zm-61.34-13.32-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L424,165C426.66,167.78,425.83,171.06,422.17,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.89,182.73S316.43,11.75,309.81,4.81c-7.12-7.46-16.57-4-16.74-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.92-.66-11.92-.66S269.93-2,258.52,1.31C245.33,5.12,57.23,52.93,57.23,52.93s-8.71,3-3.6,9.42L102.23,126S209.74,261.24,217.78,271.29s23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S480.89,182.73,480.89,182.73Zm-58.72-10.47-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L424,165C426.66,167.78,425.83,171.06,422.17,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.59 281.15 242.59 308.67 475.41 224.48 475.41 201.17 242.59 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "475.41 201.17 459.06 206.84 475.41 224.48 475.41 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.93,128.13l-7.76,1.57c17.27,21.72,105.36,132.53,112.61,141.59A15.61,15.61,0,0,0,229.53,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.89,182.73S410.36,109.41,359.82,56.84l-4.08,1.74L483.15,191.4C486.18,187.57,480.89,182.73,480.89,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.47,58.53C109,60.72,90.76,67.2,100.83,80.09s24.94,13.26,42.42,8.43S276,52.06,287.15,48.92s25.7-9.77,12.89-21.8-30.41-8.71-44.76-4.92S126,56.33,117.47,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.88,13.22l-2-2-25.08,6.74a30.42,30.42,0,0,1,3.67,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.26,70.72,65.57,78.07l1.92,2.51,25.8-6.91A9.44,9.44,0,0,1,93.26,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M322.09,17.6l-1.95-2-22.27,6a29,29,0,0,1,2.45,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.08,82.62,71,85.12l24.23-6.47A17.48,17.48,0,0,1,94,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304.43,27.77l21.74-5.92-1.93-2-21.61,5.86c.32.33.64.67.94,1S304.15,27.42,304.43,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.06,81.29,73,87.8l1.94,2.49L99.07,83.7c-.47-.53-.95-1.08-1.42-1.65C97.44,81.79,97.26,81.54,97.06,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.72,92.56l1.94,2.49,25.17-6.89c-.88-.69-1.74-1.44-2.59-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.26,26.1l-1.93-2-22.24,6.05a16.87,16.87,0,0,1,1.17,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.91,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M308.06,37.37l26.16-7.16-1.93-2L308,34.82A8.81,8.81,0,0,1,308.06,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M430.12,165.28,330.51,59.9a16.44,16.44,0,0,0-14.84-4.11l-183.54,51.5c-4.77,1.34-6.13,5.59-3,9.44l94.32,117.15a14,14,0,0,0,14.18,4.17l190.15-63.39C432.46,173.1,433.52,168.87,430.12,165.28Zm-7.95,7-184,60.7a10.85,10.85,0,0,1-11-3.26l-91-113.52c-2.4-3-1.34-6.31,2.37-7.35l177-49.59a12.75,12.75,0,0,1,11.54,3.2L424,165C426.66,167.78,425.83,171.06,422.17,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.94,217.59c-3.12-1.08-3.1-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06l-1.55,9.58a4.89,4.89,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRegularIsometric);
export default __webpack_public_path__ + "static/media/red-regular-isometric.72d86db3189f48812c497dc71b3a90f0.svg";
export { ForwardRef as ReactComponent };